"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAxiosInstance = void 0;
const axios_1 = __importDefault(require("axios"));
const getAxiosInstance = (url, apiToken) => {
    const API = axios_1.default.create();
    API.defaults.baseURL = url;
    const axiosConfig = (config) => {
        if (apiToken) {
            config.headers.Authorization = `Bearer ${apiToken}`;
        }
        return config;
    };
    API.interceptors.request.use(axiosConfig);
    return API;
};
exports.getAxiosInstance = getAxiosInstance;
